import withToast from './Toast'

export default withToast
